import request from '@/utils/request'
let baseUrl = '/api/system/'
export function getList() {
    return request({
      url: baseUrl+'level',
      method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/level.js